import {
  UniversalHelpPutFeedbackEndpointRequest,
  UniversalHelpPutFeedbackEndpointResponseSuccess,
  UniversalHelpGetFeedbackEndpointResponseSuccess,
} from '@stripe-internal/conversations-shared-dependencies';

export type DidWeResolveOption =
  UniversalHelpPutFeedbackEndpointResponseSuccess['didWeResolve'];

export type FetchFeedbackRequest = {
  conversationId: string;
};

export async function fetchFeedback(
  supportFetch: typeof fetch,
  {conversationId}: FetchFeedbackRequest,
): Promise<UniversalHelpGetFeedbackEndpointResponseSuccess> {
  const query = new URLSearchParams();
  query.set('conversationId', conversationId);

  const resp = await supportFetch(`/api/universal-help/feedback?${query}`);

  if (!resp.ok) {
    throw new Error(`error fetching fetching feedback: ${resp.status}`);
  }

  return resp.json();
}

export type SubmitFeedbackRequest = {
  conversationId: string;
  didWeResolve?: DidWeResolveOption;
  comment?: string;
  feedbackScore?: number;
};

export async function submitFeedback(
  supportFetch: typeof fetch,
  {conversationId, didWeResolve, comment, feedbackScore}: SubmitFeedbackRequest,
): Promise<UniversalHelpPutFeedbackEndpointResponseSuccess> {
  const query = new URLSearchParams();
  query.set('conversationId', conversationId);

  const requestData: UniversalHelpPutFeedbackEndpointRequest = {
    didWeResolve,
    comment,
    feedbackScore,
  };

  const resp = await supportFetch(`/api/universal-help/feedback?${query}`, {
    method: 'PUT',
    body: JSON.stringify(requestData),
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!resp.ok) {
    throw new Error(`error fetching submitting feedback: ${resp.status}`);
  }

  return resp.json();
}
